var error404 = {
    text:"Sorry, but the page you are looking for has not been found. Try checking the URL for an error, then hit the refresh button on your browser or try go home with this route",    
    welcome: 'Welcome/Home'
}
module.exports = error404



